export const sumFormFormatter = (value) => {
    let formattedValue = value
        .replace(/[^\d,.]/g, '')
        .replace('.', ',')
        .replace(/^([^,]*,)|,/g, '$1');

    if (value === '' || formattedValue === '') {
        formattedValue = '0';
    }

    const regExp = /^0,\d*/;

    if (formattedValue.length > 1 && regExp.test(formattedValue) === false && value[0] === '0') {
        formattedValue = value[1];
    }

    return formattedValue;
};

export const sumFormFormatterWithNegative = (value) => {
    const isNegative = value.startsWith('-');

    let formattedValue = value;
    if (value === '0-') {
        formattedValue = '-';
    } else {
        formattedValue = value
            .replace(/(?!^)-/g, '')
            .replace(/[^\d,.\s-]/g, '')
            .replace(/\./g, ',')
            .replace(/^([^,]*,?)|,/g, '$1');
    }

    if (value === '' || formattedValue === '') {
        formattedValue = '0';
    }

    const regExp = /^0,\d*/;
    if (
        formattedValue.length > 1 &&
        !regExp.test(formattedValue) &&
        (formattedValue.startsWith('0') || formattedValue.startsWith('-0'))
    ) {
        formattedValue = formattedValue.replace(/^0/, '');
    }

    if (isNegative && formattedValue !== '0') {
        formattedValue = '-' + formattedValue.replace(/^-/, '');
    }

    return formattedValue;
};

export const newSumFormFormatter = (value, isMoney = false) => {
    let formattedValue = value
        .replace(/[^\d,.]/g, '')
        .replace(/\./g, ',')
        .replace(/,+/g, ',')
        .replace(/^0+(?=\d)/, '');

    const parts = formattedValue.split(',');
    if (parts.length > 1) {
        formattedValue = `${parts.shift()},${parts.join('')}`;
    }

    if (formattedValue === '' || formattedValue === ',') {
        formattedValue = isMoney ? '0' : '';
    }

    return formattedValue;
};
